(function () {
    'use strict';

    angular
        .module('edufindme')
        .controller('SurveyModalController', SurveyModalController)

        SurveyModalController.$inject = ['$uibModalInstance', 'virtualFair', 'SendSurveyService'];

    function SurveyModalController($uibModalInstance, virtualFair, SendSurveyService) {
        var vm = this;

        vm.virtualFair     = virtualFair;
        vm.survey_url      = '';
        vm.attended        = 0;
        vm.ok              = ok;
        vm.cancel          = cancel;
        vm.send            = send;

        activate();

        function activate() {
            console.log(vm.virtualFair);
        }

        function ok () {
            $uibModalInstance.close();
        }

        function cancel () {
            $uibModalInstance.close();
        }

        function send() {
            var data = {
                virtual_fair_id: vm.virtualFair.expos_virtual_fair_id,
                survey_url: vm.survey_url,
                attended: vm.attended
            }

            SendSurveyService.sendSurvey(data).then(function(response){
                alertify.notify('Emails sent successfully!', 'success', 3);

            }).catch(function(err) {
                alertify.notify(err, 'danger', 3);
            });
        }

    }

})();